import React, { useEffect } from 'react';

const Toast = ({ message, type = 'success', onClose }) => {
    // Styles based on type
    const typeStyles = {
        success: 'bg-blue-600 border-blue-500 text-white shadow-lg shadow-blue-900/50',
        error: 'bg-red-600 border-red-500 text-white shadow-lg shadow-red-900/50',
        info: 'bg-blue-600 border-blue-500 text-white shadow-lg shadow-blue-900/50',
        warning: 'bg-yellow-600 border-yellow-500 text-white shadow-lg shadow-yellow-900/50',
    };

    const iconStyles = {
        success: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
        ),
        error: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
        ),
        info: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
        ),
        warning: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
        ),
    };

    return (
        <div className={`pointer-events-auto flex items-center w-full max-w-sm p-4 rounded-lg shadow-2xl border ${typeStyles[type]} animate-slide-in-down backdrop-blur-md`}>
            <div className="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg bg-white/20 text-white">
                {iconStyles[type]}
            </div>
            <div className="ml-3 text-sm font-medium">{message}</div>
            <button
                type="button"
                className="ml-auto -mx-1.5 -my-1.5 rounded-lg focus:ring-2 focus:ring-white/50 p-1.5 inline-flex h-8 w-8 text-white/80 hover:text-white hover:bg-white/20 transition-colors"
                onClick={onClose}
            >
                <span className="sr-only">Close</span>
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
    );
};

export default Toast;
